import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebase";

export const SCHEDULER_COLLECTION = "firestore_admin_schedules";

export async function listSchedules() {
  const snap = await getDocs(
    query(collection(db, SCHEDULER_COLLECTION), orderBy("createdAt", "desc"))
  );
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function createSchedule(payload) {
  const ref = await addDoc(collection(db, SCHEDULER_COLLECTION), {
    ...payload,
    status: "active",
    createdAt: new Date().toISOString(),
    lastRun: null,
    nextRun: computeNextRun(payload),
    history: [],
  });
  return ref.id;
}

export async function updateSchedule(id, patch) {
  const ref = doc(db, SCHEDULER_COLLECTION, id);
  const next = { ...patch, updatedAt: new Date().toISOString() };
  if (patch.frequency || patch.cron) next.nextRun = computeNextRun(patch);
  await updateDoc(ref, next);
}

export async function pauseSchedule(id) {
  await updateDoc(doc(db, SCHEDULER_COLLECTION, id), { status: "paused", updatedAt: new Date().toISOString() });
}

export async function resumeSchedule(id, data) {
  await updateDoc(doc(db, SCHEDULER_COLLECTION, id), {
    status: "active",
    nextRun: computeNextRun(data),
    updatedAt: new Date().toISOString(),
  });
}

export async function deleteSchedule(id) {
  await deleteDoc(doc(db, SCHEDULER_COLLECTION, id));
}

export async function appendScheduleHistory(id, entry) {
  const ref = doc(db, SCHEDULER_COLLECTION, id);
  const { getDoc } = await import("firebase/firestore");
  const snap = await getDoc(ref);
  const history = snap.data()?.history || [];
  history.unshift({ ...entry, at: new Date().toISOString() });
  await setDoc(ref, { history: history.slice(0, 50), lastRun: new Date().toISOString() }, { merge: true });
}

function computeNextRun({ frequency, cron }) {
  const now = new Date();
  if (cron) return `cron:${cron}`;
  const next = new Date(now);
  if (frequency === "hourly") next.setHours(next.getHours() + 1);
  else if (frequency === "daily") next.setDate(next.getDate() + 1);
  else if (frequency === "weekly") next.setDate(next.getDate() + 7);
  else if (frequency === "monthly") next.setMonth(next.getMonth() + 1);
  else next.setDate(next.getDate() + 1);
  return next.toISOString();
}
